'use strict';

function RoleToStringFilter() {
  return (role) => {
    if (role === 'admin') return "アカウント管理者";
    if (role === 'operator') return "オペレータ";
    if (role === 'viewer') return "閲覧者";
    if (role === 'limited_viewer') return "制限付き閲覧者";
  };
}

export default angular.module('leptonApp.RoleToStringFilter', [])
  .filter('roleToString', [RoleToStringFilter])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/filter/role_to_string/role_to_string.filter.js